<template>
    <div class="shop__options-block" style="margin-bottom: 0">
        <div class="shop__options-block-input shop__address-readonly-block">
            <div class="shop__address-readonly-label">{{Strings['Shop.LabelDeliveryPeriod']}}:</div>
            {{SelectedDeliveryPeriod.displayText}}
        </div>
        <div class="shop__options-block-desc">
            <div v-if="!ExpressSelected"><v-runtime-template :template="DeliveryPeriodDetails" /></div>
            <div v-if="ExpressSelected"><v-runtime-template :template="DeliveryPeriodExpressDetails" /></div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { DeliveryPeriodTypes } from '@/utils/constants';
    import Transaction from '@/models/Transaction'
    import VRuntimeTemplate from "v-runtime-template";

    export default {
        props: {
            mode: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            CurrentTransaction() {
                return Transaction.query().with('deliveryPeriod').first();
            },
            SelectedDeliveryPeriod() {
                return this.CurrentTransaction.deliveryPeriod;
            },
            DeliveryPeriodDetails() {
                switch (this.mode) {
                    case 'BnT':
                        return '<span>' + this.Strings['Shop.RegularDeliveryInfo_BrennTreibstoffe'] + '</span>';
                    case 'SnA':
                        return '<span>' + this.Strings['Shop.RegularDeliveryInfo_ServicesAnlagen'] + '</span>';
                    default:
                        return null;
                }

            },
            DeliveryPeriodExpressDetails() {
                return '<span>' + this.Strings['Shop.ExpressDeliveryInfo'] + '</span>';
            },
            ExpressSelected() {
                return this.SelectedDeliveryPeriod.deliveryPeriodType === DeliveryPeriodTypes.Express;
            }
        },
        components: {
            VRuntimeTemplate
        }
    };
</script>